/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table2({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
        value15: "",
        value16: "",
        value17: "",
      },
    ],
    muc2: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
        value15: "",
        value16: "",
        value17: "",
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Loại hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="4">
                Đại diện ký kết
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Thời gian thực hiện hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Trách nhiệm pháp lý và cam kết của các bên
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Đối tượng có thẩm quyền kết hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="3">
                Các nội dung liên quan đến thuế trong hợp đồng
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Bên Việt Nam
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Bên nước ngoài
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Số
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Ngày{" "}
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Từ ngày
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Đến ngày
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã số thuế</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã số thuế (nếu có)</Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)</Th>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>A: Hợp đồng TBH P&I</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center"}}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    type="text"
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    type="text"
                    rowType="muc1"
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                    rowType="muc11"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                    rowType="muc1"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                    rowType="muc1"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                    rowType="muc1"
                    type="text"
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>B: Hợp đồng TBH kỹ thuật</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
            {data.muc2.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center"}}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    type="text"
                    rowType="muc2"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    type="text"
                    rowType="muc2"
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                    rowType="muc2"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                    rowType="muc2"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                    rowType="muc2"
                    type="date"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value12"
                    value={item.value12}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold"}}>
                  <InputTable
                    id={item.id}
                    name="value13"
                    value={item.value13}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table2);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
